<template>
    <div id="session" @error="errorHandler" @click="relayout()">
        <!-- <ul>
            <li v-for="(streamer, index) in streamers" v-bind:key="index">
                <pre
                    v-if="streamer.stream && streamer.stream.connection"
                    @click="
                        stopStream(streamer.stream, streamer.stream.connection)
                    ">{{ streamer.stream.connection.data }} <i>{{ streamer.stream.id }}</i> </pre>

                <hr />
            </li>
        </ul> -->

        <section id="videos" v-if="show">
            <div
                id="layoutContainer"
                class="w-full h-screen aspect-w-3 aspect-h-2 lg:aspect-w-16 lg:aspect-h-9"
            >
                <div
                    id="subscribers"
                    ref="toktok"
                    class="absolute left-0 top-0 w-full h-full object-cover p-4"
                    :class="{ hidden: justViewing }"
                ></div>
            </div>
        </section>
    </div>
</template>

<script>
import OT from "@opentok/client";
const errorHandler = (err) => {
    alert(err.message);
};

export default {
    name: "session",
    props: {
        apiKey: {
            type: String,
            default: process.env.MIX_TOK_API,
        },
        sessionId: {
            type: String,
            default: process.env.VUE_APP_SESSION_ID,
        },
        token: {
            type: String,
            default: process.env.VUE_APP_TOKEN,
        },
        publishToken: {
            type: String,
            default: process.env.VUE_APP_TOKEN,
        },
        viewToken: {
            type: String,
            default: process.env.VUE_APP_TOKEN,
        },
        user_name: {
            type: String,
            default: null,
        },
        role: {
            type: String,
            default: "viewer",
        },
        output: {
            type: String,
            default: "webcam",
        },
        system_role: {
            type: String,
            default: "listener",
        },
    },
    data() {
        return {
            show: true,
            session: null,
            current_publisher: null,
            hasFixedRatio: false,
            justViewing: false,
            _event: null,
            source: null,
            streamers: [],
            activeStreams: [],
            options: {
                maxRatio: 3 / 2, // The narrowest ratio that will be used (default 2x3)
                minRatio: 9 / 16, // The widest ratio that will be used (default 16x9)
                fixedRatio: false, // If this is true then the aspect ratio of the video is maintained and minRatio and maxRatio are ignored (default false)
                scaleLastRow: false, // If there are less elements on the last row then we can scale them up to take up more space
                alignItems: "center", // Can be 'start', 'center' or 'end'. Determines where to place items when on a row or column that is not full
                bigClass: "OT_big", // The class to add to elements that should be sized bigger
                bigPercentage: 0.85, //0.8, // The maximum percentage of space the big ones should take up
                bigFixedRatio: true, // fixedRatio for the big ones
                bigAlignItems: "center", // How to align the big items
                smallAlignItems: "center", // How to align the small row or column of items if there is a big one
                maxWidth: Infinity, // The maximum width of the elements
                maxHeight: Infinity, // The maximum height of the elements
                smallMaxWidth: Infinity, // The maximum width of the small elements
                smallMaxHeight: Infinity, // The maximum height of the small elements
                bigMaxWidth: Infinity, // The maximum width of the big elements
                bigMaxHeight: Infinity, // The maximum height of the big elements
                // bigMaxRatio: 3 / 2, // The narrowest ratio to use for the big elements (default 2x3)
                bigMaxRatio: 9 / 16, // The narrowest ratio to use for the big elements (default 2x3)
                bigMinRatio: 9 / 16, // The widest ratio to use for the big elements (default 16x9)
                bigFirst: true, // Whether to place the big one in the top left (true) or bottom right (false).
                // You can also pass 'column' or 'row' to change whether big is first when you are in a row (bottom) or a column (right) layout
                animate: true, // Whether you want to animate the transitions
                // window: document.querySelector("body"), // Bij custom variant
                window: document.getElementById("subscribers"), // Lets you pass in your own window object which should be the same window that the element is in
                ignoreClass: "OT_ignore", // Elements with this class will be ignored and not positioned. This lets you do things like picture-in-picture
                onLayout: null, // A function that gets called every time an element is moved or resized, (element, { left, top, width, height }) => {}
            },
        };
    },
    created() {
        Eventing.listen("changeOfOpenTokToken", (source) =>
            this.joinCurrentSession(source),
        );
        Eventing.listen("stopSession", () => this.stopSessionView());
        Eventing.listen("forcedUnpublish", () => this.unpublish());
        Eventing.listen("forcedSoftUnpublish", () => this.softUnpublish());

        Eventing.listen("stoppingPublisher", (stream, connection) => {
            this.stopStream(stream, connection);
        });
    },
    mounted() {
        this.initializeSession();
    },
    beforeMount() {
        console.info("beforeMount");
        this.softUnpublish();
        // this.session = null;
    },
    beforeUnmount() {
        this.softUnpublish();
        // this.unpublish();
    },
    methods: {
        stopSessionView() {
            this.show = false;
            this.session = null;
            this.softUnpublish();
            this.unpublish();
        },
        async joinCurrentSession(source) {
            let self = this;
            if (this.source == source) {
                return;
            }
            this.source = source;
            try {
                await this.softUnpublish();
            } catch (error) {}
            setTimeout(() => {
                console.info("Role: " + self.role);
                try {
                    if (source == "webcam") {
                        self.publishNow(self.session);
                    } else if (source == "screen") {
                        self.publishDesktopNow(self.session);
                    }
                } catch (error) {
                    console.error("joinCurrentSession: " + source);
                    console.error(error);
                    Eventing.fire("resetPublishSource", "null");
                }
            }, 300);
        },
        async softUnpublish() {
            try {
                if (this.current_publisher) {
                    var publisher = this.current_publisher;
                    var session = this.session;
                    if (!session) {
                        var session = OT.initSession(
                            this.apiKey,
                            this.sessionId,
                        );
                    }
                    session.unpublish(publisher);
                    this.current_publisher = null;
                    Eventing.fire("resetPublishSource", "null");
                }
            } catch (error) {
                console.error("softUnpublish");
                console.error(error);
            }
            return;
        },
        unpublish() {
            var session = this.session;
            if (!session) {
                var session = OT.initSession(this.apiKey, this.sessionId);
            }
            var publisher = this.current_publisher;
            this.activeStreams = [];
            try {
                session.unpublish(publisher);
            } catch (error) {}
            try {
                session.disconnect();
            } catch (error) {}
            // if (document.getElementById("layoutContainer")) {
            //     // document.getElementById("layoutContainer").innerHTML = "";
            // }
            window.location.reload();
        },
        stopStream(stream, connection) {
            let self = this;
            var session = this.session;
            if (!session) {
                var session = OT.initSession(this.apiKey, this.sessionId);
            }
            self.streamers = [];
            session.forceUnpublish(stream, function (error) {
                if (error) {
                    console.log(error);
                } else {
                    console.log(
                        "Connection forced to disconnect: " + connection.id,
                    );
                    session.signal(
                        {
                            type: "removeFromRoom",
                            to: connection, // a Connection object
                            data: "unpublish",
                        },
                        function (error) {
                            if (error) {
                                console.log("signal error: " + error.message);
                            } else {
                                console.log("signal sent");
                                try {
                                    setTimeout(() => {
                                        self.makeStreamlist(
                                            session,
                                            self._event,
                                        );
                                    }, 1000);
                                } catch (error) {}
                            }
                        },
                    );
                }
            });
        },
        relayout() {
            // const initLayoutContainer = require("../vendor/opentok-layout.js");
            const initLayoutContainer = require("opentok-layout-js");
            const layout = initLayoutContainer(
                document.getElementById("layoutContainer"),
                this.options,
            );
            layout.layout();
        },
        makeStreamlist(session, event) {
            let self = this;
            self.streamers = [];
            this._event = event;
            try {
                console.log("getSubscribersForStream");
                session
                    .getSubscribersForStream(event.stream)
                    .forEach((item) => {
                        if (item.stream.name.includes("Screen:")) {
                            console.info("=SCREEN");
                            item.element.classList.add("OT_big");
                            self.hasFixedRatio = true;
                            self.options.fixedRatio = true;
                        }
                        console.info("item.stream");
                        console.info(item.stream);
                        self.streamers.push(item);
                        // subscriber.element.classList.add("webcam");
                    });
            } catch (error) {
                console.error("getSubscribersForStream");
                console.error(error);
            }
            Eventing.fire("publishStreamers", self.streamers);
        },
        initializeSession() {
            let self = this;
            var session = this.session;
            if (!session) {
                var session = OT.initSession(this.apiKey, this.sessionId);
            }

            const initLayoutContainer = require("opentok-layout-js");
            // const initLayoutContainer = require("../vendor/opentok-layout.js");

            const options = this.options;

            const layout = initLayoutContainer(
                document.getElementById("layoutContainer"),
                options,
            );
            layout.layout();

            function handleError(error) {
                if (error) {
                    Eventing.fire("resetPublishSource", "null");
                    console.error(error);
                }
            }

            session.on("signal", function (event) {
                console.log("Signal sent from connection: " + event.from.id);
                console.log("Signal data: " + event.data);
                if (event.data == "unpublish") {
                    console.warn("unpublish");

                    if (
                        self.system_role != "moderator" &&
                        self.system_role != "publisher"
                    ) {
                    } else {
                        Eventing.fire("hideVonageToolbar");
                    }

                    // self.token = self.viewToken;
                    Eventing.fire("removeFromSessionOT");
                    Eventing.fire("resetPublishSource", "null");
                }
            });

            var activeStreams = self.activeStreams;
            self.activeStreams = [];
            var activeStreams = [];

            session
                .on("streamCreated", function streamCreated(event) {
                    console.info("streamCreated");
                    console.info(event);

                    if (!activeStreams.includes(event.stream.id)) {
                        activeStreams.push(event.stream.id);
                        self.activeStreams = activeStreams;

                        var name = event.stream.connection.data;
                        session.subscribe(
                            event.stream,
                            "layoutContainer",
                            {
                                insertMode: "append",
                                width: "100%",
                                height: "100%",
                                insertMode: "append",
                                name: name,
                                showControls: true,
                                width: "33%",
                                archiveStatusDisplayMode: "on",
                                height: "50%",
                                // facingMode: "user",
                                nameDisplayMode: "on",
                                style: {
                                    nameDisplayMode: "on",
                                    buttonDisplayMode: "on",
                                    audioLevelDisplayMode: "on",
                                },
                            },
                            handleError,
                        );
                        setTimeout(() => {
                            console.warn("layoutCreate");
                            layout.layout();
                        }, 1000);

                        self.makeStreamlist(session, event);
                    }
                })
                .connect(this.apiKey, this.token, function (err) {
                    if (!err) {
                        if (self.role != "viewer") {
                            session.publish("subscribers");
                        }
                        layout.layout();
                    }
                    setTimeout(() => {
                        console.warn("layout");
                        layout.layout();
                    }, 1000);
                });

            session.on(
                "sessionDisconnected",
                function sessionDisconnected(event) {
                    console.log(
                        "You were disconnected from the session.",
                        event.reason,
                    );
                },
            );

            const interval = setInterval(function () {
                var els = document.getElementsByClassName("OT_name");
                Array.prototype.forEach.call(els, function (element) {
                    if (element.innerHTML.includes("Screen")) {
                        self.hasFixedRatio = true;
                    }
                    layout.layout();
                });
            }, 5000);

            session.on("streamDestroyed", (event) => {
                event.preventDefault();
                session
                    .getSubscribersForStream(event.stream)
                    .forEach((subscriber) => {
                        subscriber.element.classList.remove("ot-layout");

                        try {
                            setTimeout(() => {
                                self.makeStreamlist(session, event);
                            }, 1500);
                        } catch (error) {}

                        setTimeout(() => {
                            subscriber.destroy();
                            layout.layout();
                        }, 200);
                    });
            });
            if (false) {
            } else {
                setTimeout(() => {
                    self.justViewing = true;
                    layout.layout();
                }, 300);
            }
        },
        publishNow(session) {
            let self = this;
            function handleError(error) {
                if (error) {
                    console.error("handleError @ publishNow");
                    console.error(error);
                } else {
                    setTimeout(() => {
                        self.relayout();
                    }, 500);
                }
            }
            console.info("publishNow");
            console.info(session);
            if (!session) {
                var session = OT.initSession(this.apiKey, this.sessionId);
            }
            console.info(session);
            this.justViewing = true;

            var publisherOptions = {
                insertMode: "append",
                name: self.user_name,
                showControls: true,
                width: "100%",
                archiveStatusDisplayMode: "off",
                height: "50%",
                // facingMode: "user",
                videoContentHint: "detail",
                nameDisplayMode: "on",
                style: {
                    nameDisplayMode: "on",
                    buttonDisplayMode: "on",
                    audioLevelDisplayMode: "on",
                },
            };

            var publisher = OT.initPublisher(
                "layoutContainer",
                publisherOptions,
                handleError,
            );
            publisher.on({
                accessDenied: function () {
                    Eventing.fire("notify", {
                        title: self.t(
                            "vonage.failure-webcam",
                            "Webcam delen mislukt",
                        ),
                        message: self.t(
                            "vonage.failure-webcam-info",
                            "U dient toegang te geven tot uw camera en microfoon om deel te nemen als uitzender. Controleer uw instellingen en probeer het daarna nogmaals",
                        ),
                        type: "alert",
                        position: "center",
                    });
                },
            });
            self.current_publisher = publisher;

            session.publish(publisher, handleError);

            Eventing.fire("startedStreaming");

            return;
        },

        publishDesktopNow(session) {
            let self = this;
            function handleError(error) {
                if (error) {
                    console.error("handleError @ publishNow");
                    console.error(error);
                    Eventing.fire("resetPublishSource", "null");
                } else {
                    setTimeout(() => {
                        self.relayout();
                    }, 500);
                }
            }
            console.info("publishNow");
            console.info(session);
            if (!session) {
                var session = OT.initSession(this.apiKey, this.sessionId);
            }
            console.info(session);
            this.justViewing = true;
            try {
                if (true) {
                    const promise = Promise.all([
                        OT.getUserMedia({
                            videoSource: "screen",
                        }),
                        OT.getUserMedia({
                            videoSource: null,
                        }),
                    ])
                        .then(([screenStream, micStream]) => {
                            var publisher = OT.initPublisher(
                                "layoutContainer",
                                {
                                    videoSource:
                                        screenStream.getVideoTracks()[0],
                                    audioSource: micStream.getAudioTracks()[0],
                                    insertMode: "append",
                                    showControls: true,
                                    frameRate: 60,
                                    name: "Screen: " + self.user_name,
                                    videoContentHint: "detail",
                                    width: "100%",
                                    height: "100%",
                                    nameDisplayMode: "on",
                                    style: {
                                        nameDisplayMode: "on",
                                        audioLevelDisplayMode: "on",
                                        buttonDisplayMode: "on",
                                    },
                                },
                            );
                            self.hasFixedRatio = true;
                            publisher.element.classList.add("OT_big");

                            self.current_publisher = publisher;

                            publisher.on({
                                accessDenied: function () {
                                    Eventing.fire("notify", {
                                        title: self.t(
                                            "vonage.failure-screen",
                                            "Beeldscherm delen mislukt",
                                        ),
                                        message: self.t(
                                            "vonage.failure-screen-info",
                                            "Controleer uw instellingen en probeer het daarna nogmaals.",
                                        ),
                                        type: "alert",
                                        position: "center",
                                    });
                                    setTimeout(() => {
                                        window.location.reload();
                                    }, 3000);
                                },
                            });

                            session.publish(publisher, handleError);
                            // alert("OK");
                            Eventing.fire("startedStreaming");

                            setTimeout(() => {
                                self.relayout();
                            }, 500);
                        })
                        .catch((error) => {
                            console.error("error");
                            Eventing.fire("notify", {
                                title: self.t(
                                    "vonage.failure-screen",
                                    "Beeldscherm delen mislukt",
                                ),
                                message:
                                    self.t(
                                        "vonage.failure-screen-info",
                                        "Controleer uw instellingen en probeer het daarna nogmaals.",
                                    ) +
                                    "<br><br>" +
                                    error.toString() +
                                    "<br><br>Try again after page is reloaded.",
                                type: "alert",
                                position: "center",
                            });
                            setTimeout(() => {
                                window.location.reload();
                            }, 3000);
                        });
                }
            } catch (error) {
                console.error("Error@publishDesktopNow");
                console.error(error);
                Eventing.fire("resetPublishSource", "null");
                window.location.reload();
            }

            return;
        },
        handleError(error) {
            if (error) {
                console.error(error);
            }
        },
        doPublish(session, publisher) {
            function handleError(error) {
                if (error) {
                    console.error("handleError @ publishNow");
                    console.error(error);
                }
            }
        },
    },
    computed: {
        typeOfToken() {
            // alert(this.token);
            return this.token;
        },
    },
    watch: {},
};
</script>

<style>
/* .OT_subscriber {
    float: left;
}
.OT_publisher {
    float: left;
} */

#layoutContainer {
    width: 100%;
    height: 100%;
}

.container > * {
    width: 0;
    height: 0;
    opacity: 0;
}

.container > *.ot-layout {
    opacity: 1;
}
.container > * {
    transition-property: all;
    transition-duration: 0.5s;
}
</style>
